const _ = require("lodash");
const PT = require("prop-types");
const React = require("react");
const createReactClass = require("create-react-class");

const URLMake = require("../../../shared/URLMake");
const Avatar = require("../../core/view/Avatar");
const {getStudentRegistrationPage} = require("../../core/vault/OpsPage");

const styles = require("./styles/AvatarLinkGroup.css");

module.exports = createReactClass({
	displayName: "AvatarLinkGroup",

	propTypes: {
		studentsData: PT.object.isRequired,
		selectedID: PT.number,
		className: PT.string,
		// Additional avatar before other avatars
		extraAvatar: PT.object,
		isCentered: PT.bool,
	},

	getLinkTo: function(studentData) {
		if (!studentData.hasRegistered) {
			return getStudentRegistrationPage(studentData.id);
		}
		return URLMake.forParentStudent(studentData.id, {
			grade: _.get(
				studentData,
				"activity.lastPlayedData.gradeNumber",
				studentData.grade
			),
		});
	},

	render: function() {
		const {
			studentsData,
			className,
			selectedID,
			extraAvatar,
			isCentered,
		} = this.props;
		const nameClass = isCentered ? styles.nameCenter : styles.name;

		let ordered = _.map(studentsData, (studentData, sid) => {
			studentData.id = parseInt(sid);
			return studentData;
		});
		ordered = _.sortBy(ordered, s => s.displayName);

		const avatars = _.map(ordered, studentData => {
			const outerClass =
				studentData.id === selectedID ? styles.outerSelected : styles.outer;
			if (studentData.everHadBAOAccess) {
				return (
					<div className={outerClass} key={"avatarLink" + studentData.id}>
						<Avatar
							className={styles.linkAvatar}
							avatar={studentData.avatarData}
							fallbackDisplayName={studentData.displayName}
							linkTo={this.getLinkTo(studentData)}
							hasRing={true}
						/>
						<div className={nameClass}>{studentData.displayName}</div>
					</div>
				);
			}
		});

		if (extraAvatar) {
			let outerClass = styles.outer;
			if (selectedID === 0) outerClass = styles.outerSelected;
			const extraClass = ordered.length >= 6 ? styles.extraAvatarHide : "";
			avatars.unshift(
				<div key="extraAvatar" className={outerClass + " " + extraClass}>
					<Avatar
						className={styles.linkAvatar}
						avatarReplacementImgSrc={extraAvatar.imgSrc}
						avatar={{}}
						linkTo={extraAvatar.linkTo}
						hasRing={true}
					/>
					<div className={nameClass}>{extraAvatar.label}</div>
				</div>
			);
		}

		const linkClass = isCentered ? styles.mainCenter : styles.main;
		const classNames = _.filter([className, linkClass]);

		return <div className={classNames.join(" ")}>{avatars}</div>;
	},
});
